import {Component,ElementRef, NgZone, ViewChild, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleService } from 'app/main/services/roles.service';
import { Usuario } from 'app/main/models/usuario.model';
import {TranslateService} from '@ngx-translate/core';

import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import { Destinatario } from 'app/main/models/destinatario.model';



@Component({
  selector: 'app-destinatario-dialog-box',
  templateUrl: './destinatario-dialog-box.component.html',
  styleUrls: ['./destinatario-dialog-box.component.scss']
})
export class DialogBoxDestinatariosComponent {

  action: string;
  LOCAL_DATA: any;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredTipos: Observable<any[]>;
  myControl = new FormControl();

  roles = [];
  displayedColumns: string[] = ['estructura','nombre'];

  constructor(
    public dialogRef: MatDialogRef<DialogBoxDestinatariosComponent>,
    public translate: TranslateService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.action = data.action;
    this.LOCAL_DATA = {...data.dataSource};
    
  }

  @ViewChild('usuarioInput') usuarioInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;


  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {
    
  }

  

  openDialog(): void {}

}
